<template>
  <div>
    <Header
      :headerTitle="$t('m.invoicesList.title')"
      :hasBackBtn="true"
      :rightIconSrc="require('../../assets/img/dianhua.png')"
      :onRightBtnClick="call"
      :iconShow="true"
    ></Header>
    <div>
      <section
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="busy"
        infinite-scroll-distance="200"
      >
        <form v-if="list!=''" form="orderListForm">
          <div class="headerInfo items" v-for="(item,index) in list" :key="index">
            <b-form-checkbox
              :value="true"
              :checked="item.checked"
              unchecked-value="false"
              class="radios main-container"
              @change="checkedItem(item)"
            >
              <div>
                <h6>{{$i18n.locale==='zh_CN'? item.parkingName:item.parkingEnName}}
                  <span style="color:#0066B1;" v-if="item.status==6">{{$t('m.invoicesList.status6')}}</span>
                </h6>
                <p>
                  {{$t('m.invoicesList.actualInTime')}}：{{item.actualInTime}}
                  <span
                    style="color:#666;font-size:14px;font-weight:bold"
                  >&nbsp;{{item.amount}}{{$t('m.invoicesList.CNY')}}</span>
                </p>
                <p>{{$t('m.invoicesList.actualInHour')}}：{{((item.actualTime)/60).toFixed(2)}}{{$t('m.invoicesList.hours')}}</p>
              </div>
            </b-form-checkbox>
          </div>
        </form>
        <div v-if="list==''">{{$t('m.invoicesList.nullDate')}}</div>
      </section>
      <footer class="navbar-fixed-bottom" v-if="list!=''">
        <p v-if="$t('m.invoicesList.language')=='zh_CN'">共{{totalCount}}个订单,共{{totalPrices}}元</p>
        <p v-if="$t('m.invoicesList.language')=='en_US'">In total {{totalCount}} order,{{totalPrices}} {{$t('m.invoicesList.CNY')}}</p>
        <b-form-checkbox :checked="selectAllState" @change="selectAll">{{$t('m.invoicesList.selectAll')}}</b-form-checkbox>
        <b-button href="#" :disabled="totalCount==0">
          <span style="display: block;" @click="onInvoice(list.orderId)">{{$t('m.invoicesList.next')}}</span>
        </b-button>
      </footer>
    </div>
    <b-modal
      ref="myModalRef"
      id="messageBox"
      centered
      :ok-title="$t('m.phone.call')"
      :title="$t('m.phone.serviceTitle')"
      :cancel-title="$t('m.phone.cancel')"
      @ok="handleOk"
    >{{phone}}</b-modal>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
import { orderList } from "../../api/order.js";
export default {
  name: "invoicingList",
  data() {
    return {
      listAll: {},
      status: 6, //已完成状态
      invoiced: 2, //未开发票状态
      list: [], //数据
      selectAllState: false, //未选中
      totalPrices: 0, //停单总价格
      totalCount: 0, //订单总数量
      phone: "400-115-0606", //手机号
      page: 1,
      pageSize: 10,
      busy: false,
      total: 0,
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "" //提示类型
    };
  },
  methods: {
    //页面加载的数据
    loadOrderList: function() {
      let req = { page: this.page, pageSize: this.pageSize };
      req.status = this.status;
      req.invoiced = this.invoiced;
      req.isCanInvoice = 1;
      orderList(req).then(
        response => {
          if (response.data.status == 200) {
            this.listAll = response.data.result;
            response.data.result.forEach(d => {
              this.list.push(d);
            });
            this.total = response.data.total;
            this.busy = false;
            this.list.forEach(l => {
              this.$set(l, "checked", false);
            });
          } else {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        },
        err => {
          reject(err);
        }
      );
    }, //判断分页数码
    loadMore() {
      this.busy = true;
      let pages = Math.ceil(this.total / this.pageSize);
      if (this.page < pages) {
        this.page++;
        this.loadOrderList();
      } else {
        this.busy = false;
      }
    },
    //全选方法
    selectAll(state) {
      this.selectAllState = state;
      for (let index in this.list) {
        this.list[index].checked = state;
      }
      this.totalPrices = 0;
      this.totalCount = 0;
      if (state == true) {
        var sum = 0;
        var count = 0;
        for (let i in this.list) {
          sum += this.list[i].amount;
          count++;
        }
        this.totalPrices += sum;
        this.totalPrices = Math.formatFloat(this.totalPrices, 2)
        this.totalCount += count;
      } else {
        this.totalPrices = 0;
        this.totalCount = 0;
      }
    },
    //发票详情页面
    onInvoice() {
      let orderId = [];
      let parkingName = [];
      let parkingId=[];
      let companyId=[];
      let companyName=[];
      for (let i in this.list) {
        if (this.list[i].checked) {
          orderId.push(this.list[i].orderId);
          parkingName.push(this.list[i].parkingName);
          parkingId.push(this.list[i].parkingId);
          companyId.push(this.list[i].companyId);
          companyName.push(this.list[i].companyName);
        }
      }

     this.$router.push("/invoicingInfo/" + orderId + "/" + this.totalPrices);
    //  this.$router.push("/invoicingInfo/" + orderId + "/" + this.totalPrices+"/"+parkingName+"/"+companyName+"/"+companyId+"/"+parkingId);

    },
    //单选返回
    checkedItem(item) {
      item.checked = !item.checked;
      var flag = true;
      for (let index in this.list) {
        if (!this.list[index].checked) {
          flag = false;
          break;
        }
      }
      this.selectAllState = flag;
      var sum = 0;
      var count = 0;
      if (item.checked == true) {
        sum += item.settlementAmount;
        count++;
      } else if (item.checked == false) {
        sum = Math.formatFloat(sum - item.settlementAmount, 2);
        count--;
      }
      this.totalPrices = Math.formatFloat(this.totalPrices + sum, 2);
      this.totalCount += count;
    },
    call() {
      this.$refs.myModalRef.show();
    },
    handleOk: function() {
      window.location.href = "tel:" + this.phone;
    }
  },
  //加载事件
  created() {
    this.loadOrderList();
    this.totalPrices = 0;
    this.totalCount = 0;
  }
};
</script>
<style scoped>
.header-container {
  background-color: black !important;
}
section {
  margin-bottom: 120px;
}
section .headerInfo {
  margin: 0 0px;
}
section .main-container{
  padding-top: 9px;
 padding-bottom: 4px;
}
section .headerInfo .main-container {
  margin:0 10px;
}
section .headerInfo .radios h6{
  margin-bottom: 6px;
}

section .items {
  margin-top: 10px;
  border-bottom: 8px solid #e9e9e9;
  border-top: 0;
  padding: 0 10px;
}
section .items:last-child {
  border-bottom: 0;
}
footer {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  bottom: 0px;
  left: 0;
  width: 100%;
  padding: 0px;
  background-color: #ffffff;
  border-top: 1px solid #efefef;
}
footer .custom-control {
  margin-top: 20px;
}
footer p {
  margin-bottom: 0px;
  line-height: 30px;
  color: #000;
  font-size: 14px;
  text-align: left;
  margin: 0px;
  border-bottom: 1px solid #c9c9c9;
  border-top: 1px solid #c9c9c9;
  padding: 0 10px;
}
footer a {
  padding-bottom: 5px !important;
  display: inline-block;
  text-align: center;
  margin-top: 17px;
  margin-right: 30px;
  margin-bottom: 20px;
  background-color: #0066B1;
  border: 0px;
  color: #fff;
  line-height: 40px;
  float: right;
  width: 50%;
  border-radius: 5px;
}

</style>


